export const today = require("./dashboard_goals_today.json");
export const yesterday = require("./dashboard_goals_yesterday.json");
export const week = require("./dashboard_goals_week.json");
export const month = require("./dashboard_goals_month.json");
